<template>
    <div class="promo-blue-body d-flex justify-content-around flex-wrap blue-background">
        <div class="m-3  item" data-toggle="tooltip" data-placement="top" title="Tooltip on top">
            <img src="@/assets/attestat.svg" /><br /><br />
            <p>
                {{ $t('certificate') }}
            </p>
        </div>
        <div class="m-3  item">
            <img src="@/assets/diplom.svg" /><br /><br />
            <p>
                {{ $t('diploma') }}
            </p>
        </div>
        <div class="m-3  item">
            <img src="@/assets/stipendiya.svg" /><br /><br />
            <p>
                {{ $t('scholarship') }}
            </p>
        </div>
        <div class="m-3  item">
            <img src="@/assets/kursi.svg" /><br /><br />
            <p>
                {{ $t('courses') }}
            </p>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="css">
.promo-blue-body {
    padding-top: 8em;
    padding-bottom: 8em;
    padding-left: 5em;
    padding-right: 5em;
}

.item {
    display: block;
}

.item img {
    width: 8rem;
    height: 8rem;
}

.promo-blue-body p {
    color: white;
    margin: 0;
    padding: 0;
}
</style>